import React from 'react';
import PropTypes from 'prop-types';

import data from './data';

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCollegeText: '',
      selectedLastName: '',
    };

    this.handleCollegeChange = this.handleCollegeChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
  }

  componentWillUnmount() {
    this.setState({
      selectedCollegeText: '',
      selectedLastName: '',
    });
  }

  handleCollegeChange(event) {
    this.setState({
      selectedCollegeText: event.target.value,
      selectedLastName: '',
    });
  }

  handleLastNameChange(event) {
    this.setState({ selectedLastName: event.target.value });
  }

  render() {
    const { selectedCollegeText, selectedLastName } = this.state;
    const { sessionType } = this.props;
    let selectedURL;
    if (selectedCollegeText) {
      const selectedCollege = data.find((college) => college.name === selectedCollegeText);
      if (selectedCollege.lastName && selectedLastName) {
        selectedURL = selectedCollege.lastName
          .find((lastName) => lastName.value === selectedLastName)[sessionType];
      } else {
        selectedURL = selectedCollege[sessionType];
      }
    }
    return (
      <div className="k-card-form">
        <div className="k-card-form-title">
          Schedule an Appointment
        </div>
        <div className="k-card-form-body">
          <select name="college" className="college-select" value={selectedCollegeText} onChange={this.handleCollegeChange}>
            <option value="" disabled hidden>Select your School/College</option>
            {data
              .filter((college) => (college[sessionType]
                || (college.lastName && college.lastName[0][sessionType])))
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((college) => (
                <option key={college.name} value={college.name}>{college.name}</option>
              ))}
          </select>
          {selectedCollegeText
            && data.find((college) => (college.name === selectedCollegeText)).lastName
            ? (
              <div className="last-name">
                <p><strong>First letter of your last/family name</strong></p>
                <fieldset onChange={this.handleLastNameChange}>
                  {/*
                  eslint jsx-a11y/label-has-associated-control: ["error", { assert: "either" } ]
                  */}
                  {data
                    .find((college) => (college.name === selectedCollegeText)).lastName
                    .map((segment) => (
                      <label>
                        <input type="radio" value={segment.value} checked={selectedLastName === segment.value} />
                        {segment.value}
                      </label>
                    ))}
                </fieldset>
              </div>
            ) : null}
          {selectedCollegeText
          && (!data.find((college) => (college.name === selectedCollegeText)).lastName
          || selectedLastName)
            ? (
              <a
                className="k-button"
                href={selectedURL}
              >
                Schedule
              </a>
            ) : null}
        </div>
      </div>
    );
  }
}

Form.propTypes = {
  sessionType: PropTypes.string.isRequired,
};

export default Form;
